import axios from 'axios'
import type {
  CompanyDetailResponse,
  CompanyFilters,
  CompanyListRequest,
  CompanyListResponse,
  CompanyPatchRequest,
  CountResponse,
} from 'types'

export const companyList = (request: CompanyListRequest) =>
  axios
    .get<CompanyListResponse>('/api/companies', { params: request })
    .then((res) => res.data)

export const companyCount = (filters?: CompanyFilters) =>
  axios
    .get<CountResponse>('/api/companies/count', { params: { filters } })
    .then((res) => res.data)

export const companyGet = (uuid: string) =>
  axios
    .get<CompanyDetailResponse>(`/api/companies/${uuid}`)
    .then((res) => res.data)

interface CompanyPatchPayload {
  uuid: string
  request: CompanyPatchRequest
}

export const companyPatch = ({ uuid, request }: CompanyPatchPayload) =>
  axios
    .patch<CompanyDetailResponse>(`/api/companies/${uuid}`, request)
    .then((res) => res.data)

export const COMPANY_EXPORT_ENDPOINT = '/api/companies/export'
